import { Environment } from '@dvag/dfs-constant-config';

export const getDevEnv = (): Environment => window.dfs?.env || 'dev';
